import React from "react";
import "./Hamburger.css";
export default function Hamburger({ onClick, open, buttonRef }) {
  return (
    <button
      className={`hamburger ${open ? "open" : ""}`}
      onClick={onClick}
      aria-label="Toggle menu"
      ref={buttonRef}
    >
      <span className="bar"></span>
      <span className="bar"></span>
      <span className="bar"></span>
    </button>
  );
}
